/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateAdminRolesMutationVariables = Types.Exact<{
  input: Types.UserUpdateInput;
}>;


export type UpdateAdminRolesMutation = { __typename: 'Mutation', userUpdate: { __typename: 'UserUpdatePayload', user: { __typename: 'User', id: string, roles: Array<Types.Role>, serviceAdminRoles: Array<Types.ServiceAdminRole> } } };


export const UpdateAdminRolesDocument = gql`
    mutation UpdateAdminRoles($input: UserUpdateInput!) {
  userUpdate(input: $input) {
    user {
      id
      roles
      serviceAdminRoles
    }
  }
}
    `;
export type UpdateAdminRolesMutationFn = ApolloReactCommon.MutationFunction<UpdateAdminRolesMutation, UpdateAdminRolesMutationVariables>;

/**
 * __useUpdateAdminRolesMutation__
 *
 * To run a mutation, you first call `useUpdateAdminRolesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdminRolesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAdminRolesMutation, { data, loading, error }] = useUpdateAdminRolesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAdminRolesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAdminRolesMutation, UpdateAdminRolesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAdminRolesMutation, UpdateAdminRolesMutationVariables>(UpdateAdminRolesDocument, options);
      }
export type UpdateAdminRolesMutationHookResult = ReturnType<typeof useUpdateAdminRolesMutation>;
export type UpdateAdminRolesMutationResult = ApolloReactCommon.MutationResult<UpdateAdminRolesMutation>;
export type UpdateAdminRolesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateAdminRolesMutation, UpdateAdminRolesMutationVariables>;